export const ATTACHMENTS_IN_PROGRESS = 'IN_PROGRESS';
export const ATTACHMENTS_SUCCESS = 'SUCCESS';
export const ATTACHMENTS_ERROR = 'ERROR';
